import { useEffect, useRef } from "react";
import { useShallow } from "zustand/shallow";

import { useBoundStore } from "../store";

export function useUpdateStreakOnAppOpen() {
  const userId = useBoundStore(useShallow((state) => state.user.id));
  const updateStreak = useBoundStore(useShallow((state) => state.dailyStats.updateStreak));
  const hasUpdatedRef = useRef(false);

  useEffect(() => {
    if (userId && !hasUpdatedRef.current) {
      hasUpdatedRef.current = true;
      updateStreak();
    }
  }, [userId, updateStreak]);
}
